import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { MaskPhoneDirective } from "./mask-phone/mask-phone.directive";
import { PopoverDirective } from "./popover/popover.directive";

const MYDIRECTIVES = [
    MaskPhoneDirective,
    PopoverDirective
]

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ...MYDIRECTIVES
    ],
    exports: [
        ...MYDIRECTIVES
    ]
})

export class DirectiveModule { }


// WEBPACK FOOTER //
// ./src/app/directives/directive.module.ts